import { IDParams } from './utils'

export const portabilityDemo = {
  root: {
    pattern: '/portability/:id',
    getURL: ({ id }: IDParams) => `/portability/${id}`,
  },
}
